var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcLike = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.6,
  d: "M23.426 8.518c-2.747-1.962-6.022-.68-7.286.438a.216.216 0 0 1-.285 0c-1.277-1.114-4.723-2.36-7.286-.438-4.557 3.418-3.436 10.81 7.325 17.084a.2.2 0 0 0 .205-.004c11.895-7.404 11.316-14.23 7.327-17.08Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLike);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };